// eslint-disable-line
import * as $ from 'jquery';

interface BreakpointsInterface {
    XS: number;
    SM: number;
    MD: number;
    LG: number;
    XL: number;
}

interface ActualScreenInterface {
    WIDTH: number;
    HEIGHT: number;
}

export const Breakpoints: BreakpointsInterface = {
    XS: 0,
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
};
export const ActualScreen: ActualScreenInterface = {
    WIDTH: $('body').outerWidth(),
    HEIGHT: $('body').outerHeight(),
};

export function getActualScreen() {
    ActualScreen.WIDTH = $('body').width();
    ActualScreen.HEIGHT = $('body').height();
};

/**
 * @function onMobileOnly
 * @memberOf ResponsivenessHooks
 * @param none - Dont mind these 3 params. These are required only to get method name that you'll apply this Hook for. 
 * @description Hook for components (CLASS ONLY), to run tagged method on Mobile screen size only. Mobile screen size
 * is determined by Medium Breakpoint. Method will run only if actual screen size is greater than medium breakpoint
 * 
 * @example ````Just put this hook on the top of your method like this:
```
@onMobileOnly
private static myMethodToBeFiredOnlyOnDestop() {
     ...rest of the method
 }
```` @see If your IDE in the documentation inspection inserted star symbols (*) before and after hook name - ignore them. You need to call it without these symbols 
 */
export function onMobileOnly(target: Object, key: string, descriptor: TypedPropertyDescriptor<any>) {
    let originalMethod = descriptor.value;

    descriptor.value = function(...args) {
        getActualScreen();
        const isMobile = ActualScreen.WIDTH <= Breakpoints.MD; 

        if (isMobile) {
            originalMethod.apply(this, args);
        } 
    };

    return descriptor;
}

/**
 * @function onDesktopOnly
 * @memberOf ResponsivenessHooks
 * @param none - Dont mind these 3 params. These are required only to get method name that you'll apply this Hook for. 
 * @description Hook for components (CLASS ONLY), to run tagged method on Desktop screen size only. Desktop screen size
 * is determined by Medium Breakpoint. Method will run only if actual screen size is greater than medium breakpoint
 * 
 * @example ````Just put this hook on the top of your method like this:
```
@onDesktopOnly
private static myMethodToBeFiredOnlyOnDestop() {
     ...rest of the method
 }
```` @see If your IDE in the documentation inspection inserted star symbols (*) before and after hook name - ignore them. You need to call it without these symbols 
 */
export function onDesktopOnly(target: Object, key: string, descriptor: TypedPropertyDescriptor<any>) {
    let originalMethod = descriptor.value;

    descriptor.value = function(...args) {
        getActualScreen();
        const isDesktop = ActualScreen.WIDTH >= Breakpoints.MD; 
        
        if (isDesktop) {
            originalMethod.apply(this, args);
        } 
    };

    return descriptor;
}
// eslint-disable-line
import * as $ from 'jquery';

interface BreakpointsInterface {
    XS: number;
    SM: number;
    MD: number;
    LG: number;
    XL: number;
}

interface ActualScreenInterface {
    WIDTH: number;
    HEIGHT: number;
}

export const Breakpoints: BreakpointsInterface = {
    XS: 0,
    SM: 576,
    MD: 768,
    LG: 992,
    XL: 1200,
};
export const ActualScreen: ActualScreenInterface = {
    WIDTH: $('body').outerWidth(),
    HEIGHT: $('body').outerHeight(),
};

export function getActualScreen() {
    ActualScreen.WIDTH = $('body').width();
    ActualScreen.HEIGHT = $('body').height();
};

/**
 * @function onMobileOnly
 * @memberOf ResponsivenessHooks
 * @param none - Dont mind these 3 params. These are required only to get method name that you'll apply this Hook for. 
 * @description Hook for components (CLASS ONLY), to run tagged method on Mobile screen size only. Mobile screen size
 * is determined by Medium Breakpoint. Method will run only if actual screen size is greater than medium breakpoint
 * 
 * @example ````Just put this hook on the top of your method like this:
```
@onMobileOnly
private static myMethodToBeFiredOnlyOnDestop() {
     ...rest of the method
 }
```` @see If your IDE in the documentation inspection inserted star symbols (*) before and after hook name - ignore them. You need to call it without these symbols 
 */
export function onMobileOnly(target: Object, key: string, descriptor: TypedPropertyDescriptor<any>) {
    let originalMethod = descriptor.value;

    descriptor.value = function(...args) {
        getActualScreen();
        const isMobile = ActualScreen.WIDTH <= Breakpoints.MD; 

        if (isMobile) {
            originalMethod.apply(this, args);
        } 
    };

    return descriptor;
}

/**
 * @function onDesktopOnly
 * @memberOf ResponsivenessHooks
 * @param none - Dont mind these 3 params. These are required only to get method name that you'll apply this Hook for. 
 * @description Hook for components (CLASS ONLY), to run tagged method on Desktop screen size only. Desktop screen size
 * is determined by Medium Breakpoint. Method will run only if actual screen size is greater than medium breakpoint
 * 
 * @example ````Just put this hook on the top of your method like this:
```
@onDesktopOnly
private static myMethodToBeFiredOnlyOnDestop() {
     ...rest of the method
 }
```` @see If your IDE in the documentation inspection inserted star symbols (*) before and after hook name - ignore them. You need to call it without these symbols 
 */
export function onDesktopOnly(target: Object, key: string, descriptor: TypedPropertyDescriptor<any>) {
    let originalMethod = descriptor.value;

    descriptor.value = function(...args) {
        getActualScreen();
        const isDesktop = ActualScreen.WIDTH >= Breakpoints.MD; 
        
        if (isDesktop) {
            originalMethod.apply(this, args);
        } 
    };

    return descriptor;
}
